/* nplus-leasing-deposit-service.js — endpoint resolution for the Lease/Finance forms.
   Two backend routes share this file: the card-deposit combined flow, and the
   no-payment inquiry flow (used when a block's require_deposit_payment is off).
   Classic script: exposes window.nplusLeasingDeposit. No dependencies. */
(function () {
  'use strict';

  // The provider landing pages' product links add ?leasing_provider=<provider>, so a lease enquiry
  // from that page view is a landing-page lead (draft tag + HubSpot lease_enquiry_source). Read once
  // when this script loads: a later variant change that rewrites the URL keeps it.
  var LANDING_LEAD = (function () {
    try { return new URLSearchParams(window.location.search).has('leasing_provider'); } catch (e) { return false; }
  })();
  function landingLeadSource() { return LANDING_LEAD ? 'lease-source-landing' : ''; }

  function backendBase() {
    var host = window.location.hostname;
    var isLocal = host === 'localhost' || host === '127.0.0.1';
    return (isLocal && window.__BACKEND_BASE) ? window.__BACKEND_BASE.replace(/\/$/, '') : '';
  }

  function resolveEndpoint() {
    var base = backendBase();
    return base ? base + '/create-leasing-deposit' : '/apps/nplus-deposit/create-leasing-deposit';
  }

  function resolveInquiryEndpoint() {
    var base = backendBase();
    return base ? base + '/create-leasing-inquiry' : '/apps/nplus-deposit/create-leasing-inquiry';
  }

  // Failures reject with err.code 'invalid_email' (backend 422 {"error":"invalid_email","field":"email"})
  // or 'server_error' (anything else, incl. a non-JSON body). err.message is for the console
  // only — the form shows its own translated text and never backend or JSON-parser text.
  // Ad attribution (UTMs, gclid, fbc) from nplus-attribution.js, only with marketing consent.
  function withAttribution(payload) {
    var a = window.nplusAttribution && typeof window.nplusAttribution.get === 'function' ? window.nplusAttribution.get() : null;
    if (!a) return payload;
    var out = {};
    for (var k in payload) if (Object.prototype.hasOwnProperty.call(payload, k)) out[k] = payload[k];
    out.attribution = a;
    return out;
  }

  function post(url, payload) {
    payload = withAttribution(payload);
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().catch(function () { return null; }).then(function (body) {
        if (r.ok && body) return body;
        var err = new Error('nplus-deposit request failed (' + r.status + ')');
        err.code = body && body.error === 'invalid_email' ? 'invalid_email' : 'server_error';
        throw err;
      });
    });
  }

  function createInquiryWithDeposit(payload) {
    return post(resolveEndpoint(), payload); // { clientSecret, customerId }
  }

  function createLeasingInquiry(payload) {
    return post(resolveInquiryEndpoint(), payload); // { draftOrderId, customerId }
  }

  window.nplusLeasingDeposit = {
    resolveEndpoint: resolveEndpoint,
    resolveInquiryEndpoint: resolveInquiryEndpoint,
    createInquiryWithDeposit: createInquiryWithDeposit,
    createLeasingInquiry: createLeasingInquiry,
    landingLeadSource: landingLeadSource
  };
})();
